import React from "react";
import LayoutMain from "../../components/Layout/Main/Main";
import Carousel from "../../Partials/Carousel/index";
import Accordion from "../../Partials/Accordion/index";
import Section from "../../Partials/Section/index";
import GridItemCollection from "../../Partials/GridItem/Collection";
import ProductItemCollection from "../../Partials/ProductItem/Collection";
import ServiceBanner from "../../Partials/ServiceBanner";


import DataProjects from '../../Data/projects'
import DataShop from "../../Data/Shop";
import BannerWithButton from "../../Partials/BannerWithButton";

const Index = () => {
  return (
    <div>
      <LayoutMain>
        <Carousel />
        <Section className="pt-140 pb-140 pt-sm-0 pb-sm-70">
          <div className="container-2">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Accordion />
              </div>
            </div>
          </div>
        </Section>
        <Section>
          <div className="row">
            <GridItemCollection data={DataProjects.slice(0, 6)} />
          </div>
          <div className="text-center mt-60 mt-sm-20">
            <a
              href="/project-list"
              className="btn btn-grey-border btn-block center-block btn-all-project"
            >
              All Projects
            </a>
          </div>
        </Section>
        <Section className="bg-oliva pt-70 pb-70 pt-sm-25 pb-sm-40 position-relative overflow-hidden">
            <div className="bg-dark-oliva our-products-half-bg"></div>
            <div className="container-3">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <h1 className="text-center product-title">Products</h1>
                </div>
              </div>
              <div className="row">
                <ProductItemCollection data={DataShop} />
              </div>
              <BannerWithButton link='/shop' title='Shop All'/>
            </div>
        </Section>
        <ServiceBanner  />
      </LayoutMain>
    </div>
  );
};

export default Index;
